const budgetConciliationHeader = [
  {
    group: 'Orçamento BTLeo Líquido',
    columns: [
      {
        name: 'Id',
        id: 'orcamento-id',
        show: false
      },
      {
        name: 'Ano',
        id: 'orcamento-ano',
        show: true
      },
      {
        name: 'Empresa',
        id: 'orcamento-empresa',
        show: true
      },
      {
        name: 'Loja',
        id: 'orcamento-loja',
        show: true
      },
      {
        name: 'Fator Venda Bruta',
        id: 'orcamento-fator-venda',
        show: true
      },
      {
        name: 'Real + Proj. Ano Atual',
        id: 'orcamento-real-ano-atual',
        show: true
      },
      {
        name: 'Previsão Orçamento',
        id: 'orcamento-previsao-orcamento',
        show: true
      },
      {
        name: 'Crescimento (%)',
        id: 'orcamento-crescimento-perc',
        show: true
      },
      {
        name: 'Orçamento Ajustado',
        id: 'orcamento-ajustado',
        show: true
      },
      {
        name: '',
        id: 'orcamento-alterado',
        show: true
      },
      {
        name: 'Crescimento Ajustado',
        id: 'orcamento-crescimento-ajustado',
        show: true
      }
    ]
  },
  {
    group: 'Orçamento Dias Úteis',
    columns: [
      {
        name: 'Real + Proj. Ano Atual',
        id: 'orcamento-du-proj-ano-atual',
        show: true
      },
      {
        name: 'Previsão Orçamento',
        id: 'orcamento-du-previsao-orcamento',
        show: true
      },
      {
        name: 'Orçamento ajustado',
        id: 'orcamento-du-ajustado',
        show: true
      }
    ]
  }
]

export default budgetConciliationHeader
